import moment from 'moment-timezone'

const formatDateAndTime = (date) => {
	if (!date || date === '') return '-'
	date = new Date(date)
	date.setHours(date.getHours() + 3)
	const _date = moment.tz(date, 'America/Sao_Paulo')
	return _date.format('DD/MM/YYYY - HH:mm')
}

export { formatDateAndTime }
